<template>
  <PageLayout>
    <div class="profile">
      <div class="profile-back">
        <a class="profile-back-btn" @click.prevent="goToItinerary">
          <i class="material-icons vtd-icon-2 vtd-mr-3"></i><span>Go To Itinerary</span>
        </a>  
      </div>

        <div class="profile-container">
          <div class="address-block" id="empty"></div>
          <div class="passenger-block-container">
            <div class="d-flex">
              <i class="material-icons warning-icon">&#xE002;</i> 
              <h5 class="warning-title">Important: Additional Contact Information</h5>
            </div>
            <p>
              Please ensure that you have completed as much contact information as you are able to for all people travelling on this booking. 
              This will assist us in the event of needing to urgently contact you whilst overseas. 
            </p>
          </div>
        </div>
        
      <div class="profile-container">
        <ProfileAddress
          v-if="profile"
          :profile="profile"
        />
        <ProfileMembers
          v-if="profile"
          :profile="profile"
        />
      </div>
    </div>
  </PageLayout>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import PageLayout from "@/partials/page-layout"
import ProfileAddress from "./address"
import ProfileMembers from "./members"
export default {
  components: {
    PageLayout,
    ProfileAddress,
    ProfileMembers
  },
  computed: {
    ...mapState({profile: state => state.profile.data})
  },
  created() {
    this.loadProfileInfo()
  },
  methods: {
    onClickBooking(number) {
      this.switchBooking(number)
    },
    goToItinerary() {
      this.$router.push('booking')
    },
    ...mapActions({
      loadProfileInfo: 'profile/loadProfileInfoAction',
    }),
  }
}
</script>

<style lang="scss">
  @import './style.scss';
  #empty {
    background: none;
  }
</style>
